import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { getUTCStartDay } from "../../../utils/dates";
import { selectorIsRequirementArchived } from "./selectorIsRequirementArchived";

export const selectorIsRequirementInEligibilityGracePeriod = ({
  requirement,
  now = new Date()
}: {
  requirement: IRequirementResponse;
  now?: Date;
}): boolean => {
  const { effectiveDate, status } = requirement;

  if (
    selectorIsRequirementArchived(requirement) ||
    (status !== RequirementStatus.Incomplete &&
      status !== RequirementStatus.PendingReview) ||
    requirement.replacedRequirement ||
    !(effectiveDate instanceof Date) ||
    Number.isNaN(effectiveDate.getTime())
  ) {
    return false;
  }

  return getUTCStartDay(effectiveDate) > getUTCStartDay(now);
};
